<template>
  <div>
    <div class="p-box">
      <div class="p-box__body">
        <ValidationObserver v-slot="{ handleSubmit, valid }">
          <form v-if="!loading" @submit.prevent="handleSubmit(onSubmit)">
            <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="variableName" :name="$t('models.parameter.variableName')" rules="required">
              <label class="c-formLabel">
                {{ $t('models.parameter.name') }}
              </label>
              <span v-for="error in errors" :key="error" class="c-error-msg">
                {{ error }}
              </span>
              <TextField :model-value="value" class="c-textField" :placeholder="$t('labels.placeholder.enter', { value: $t('models.parameter.variableName') })" @update:model-value="handleChange" />
            </ValidationProvider>

            <div v-if="currentParameterId" class="parameterList p-table__content">
              <table>
                <thead>
                  <tr>
                    <th>
                      <span>{{ $t("models.parameter.storeName") }}</span>
                    </th>
                    <th>
                      <span>{{ $t("models.parameter.parameterValue") }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in values" :key="value.storeUuid">
                    <td>{{ value.storeName }}</td>
                    <td>
                      <TextField v-model="value.value" class="c-textField" :placeholder="$t('labels.placeholder.enter', { value: $t('models.parameter.variableName') })" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="c-button c-button--right">
              <router-link class="c-button__item c-button__item--outline-cancel" :to="{ name: 'CompaniesManagementParameters', params: { company_uuid: currentCompanyUuid } }">{{ $t('labels.cancel') }}</router-link>
              <button class="c-button__item c-button__item--primary" :class="{'c-button__item--disabled': !valid || isEmptyValues}" type="submit" :disabled="(!valid || isEmptyValues)">
                {{ $t('labels.save') }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <Loading v-if="loading" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loading from '../components/Loading'
import TextField from '../components/TextField'

export default {
  name: 'CompaniesParameterForm',
  components: {
    Loading,
    TextField
  },
  data() {
    return {
      variableName: '',
      values: []
    }
  },
  computed: {
    ...mapState({
      parameter: state => state.companiesParameter.data,
      parameterLoading: state => state.companiesParameter.loading,
    }),
    loading() {
      return this.parameterLoading
    },
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentParameterId() {
      return this.$route.params.parameter_id
    },
    isEmptyValues() {
      if(!this.currentParameterId){
        return false
      }
      return this.values.every((value) => !value.value)
    }
  },
  async created() {
    if(this.currentParameterId){
      await this.readParameter()

      this.variableName = this.parameter.name
      this.values = this.parameter.values
    }
  },
  methods: {
    ...mapActions({
      readParameter: 'companiesParameter/readParameter',
      createParameter: 'companiesParameter/createParameter',
      updateParameter: 'companiesParameter/updateParameter'
    }),
    async onSubmit() {
      let isSuccess

      if(this.currentParameterId) {
        if (confirm(this.$t('pages.companies.management.parameters.confirmToUpdate'))) {
          const _values = {}
          this.values.forEach((value) => {
            _values[value.storeUuid] = value.value
          })

          isSuccess = await this.updateParameter({
            payload: {
              parameter: {
                name: this.variableName,
                values: _values
              }
            }
          })
        }
      } else {
        isSuccess = await this.createParameter({
          payload: {
            parameter: {
              name: this.variableName
            }
          }
        })
      }

      if(isSuccess) {
        this.$router.push({ name: 'CompaniesManagementParameters', params: { company_uuid: this.currentCompanyUuid } })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.parameterList {
  margin-top: 32px;
}
</style>
